import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import classNames from "classnames";
import {
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Nav,
  NavItem
} from "reactstrap";
import reportsConfig from "./reportsConfig";
import SingleReport from "./SingleReport";
import SingleRow from "./SingleRow";
import Chart from "./Chart";

export default props => {
  const { data, singles, topTrends, tables, charts, onTableRowDetails, showDetailsButton, showNav, location, ...rest } = props;
  const [activeId, setActiveId] = useState();
  if (!data) return null;
  return (
    <div {...rest}>
      <Row noGutters>
        {Object.keys(reportsConfig.single).map(key => {
          if (!data[key] || (singles && !singles.includes(key))) return null;
          const item = reportsConfig.single[key];
          return (
            <Col
              xl="2"
              md="4"
              sm="6"
              xs="12"
              key={`analysis-${key}`}
              className="p-2"
            >
              <SingleReport
                key={`single-${key}`}
                {...item}
                value={data[key]}
              />
            </Col>
          )
        })}
      </Row>
      {charts &&
        <div dir="ltr">
          <Row noGutters>
            {Object.keys(reportsConfig.charts).map(key => {
              const item = reportsConfig.charts[key];
              if (!data[key]) return null;
              return (
                <Col sm="6" key={`chart-${key}`} className="p-2">
                  <Chart
                    {...item}
                    data={data[key]}
                    label={key}
                  />
                </Col>
              )
            })}
          </Row>
        </div>
      }
      {showNav &&
        <div style={{ position: 'sticky', top: 56, backgroundColor: '#fff', zIndex: 10 }} className="p-2">
          <Nav pills justified>
            {
              [
                { key: 'album', label: 'آلبوم‌ها' },
                { key: 'artist', label: 'هنرمندان' },
                { key: 'channel', label: 'کانال‌ها' },
                { key: 'tag', label: 'تگ‌ها' },
                { key: 'track', label: 'آهنگ‌ها' },
                { key: 'user', label: 'کاربران' }
              ].map(item => {
                if (!Object.keys(data).filter(key => key.toLowerCase().indexOf(item.key) > -1).length) {
                  if (props.location.hash.replace('#', '') === item.key) {
                    return <Redirect to="/reports/analysis" />
                  }
                  return null;
                };
                return (
                  <NavItem key={`report-nav-${item.key}`}>
                    <Link onClick={() => window.scroll(0, document.getElementById('tables').offsetTop - 120)} to={{ hash: `#${item.key}` }} className={classNames("nav-link", { 'active': props.location.hash.replace('#', '') === item.key })}>{item.label}</Link>
                  </NavItem>
                )
              })
            }
          </Nav>
        </div>
      }
      {(topTrends || tables) &&
        <Row className="mt-4" noGutters id="tables">
          {Object.keys(reportsConfig.tables).map(key => {
            if (!data[key] || (topTrends && !topTrends.includes(key))) return null;
            const { label, ...item } = reportsConfig.tables[key];
            if (showNav && key.toLowerCase().indexOf(props.location.hash.replace('#', '')) === -1) return null;
            return (
              <Col xs="12" sm="6" xl="3" key={`top-trends-${key}`} className="p-2" id={key}>
                <ListGroup>
                  <ListGroupItem className="text-center"><strong>{label}</strong></ListGroupItem>
                  {data[key].slice(0, topTrends && 3).map(report => (
                    <SingleRow
                      {...item}
                      key={`top-trends-${key}-${report.key}`}
                      onClick={() => setActiveId(!activeId || activeId !== report.key ? report.key : null)}
                      className={classNames("list-group-item list-group-item-action d-flex align-items-center justify-content-between", { 'list-group-item-primary': activeId === report.key })}
                      active={activeId === report.key}
                      type={key.split(/(?=[A-Z][^A-Z])/)[1].toLowerCase()}
                      id={report.key}
                      name={report.name || report.key}
                      value={report.value}
                      showDetailsButton={showDetailsButton}
                      onDetails={onTableRowDetails}
                    />
                  ))}
                </ListGroup>
              </Col>
            )
          })
          }
        </Row>
      }
    </div>
  )
}